import jsPDF from 'jspdf';

// ============================================
// 1. IMPORTACIONES DE IMÁGENES DESDE ASSETS
// ============================================
import logoGymart1 from '../assets/logo_1.png';
import logoGymart2 from '../assets/logo_2.png';
import instagramImg from '../assets/Instagram.png';
import emailImg from '../assets/correo.png';
import facebookImg from '../assets/facebook.png';
import telefonoImg from '../assets/telefono.png';

// ============================================
// 2. IMPORTACIÓN DE FUENTE IMPACT DESDE ASSETS
// ============================================
import impactFont from '../assets/Impact.ttf';

// ============================================
// 3. UTILIDADES - CONVERSOR A BASE64
// ============================================

const fileToBase64 = async (fileUrl) => {
  try {
    const response = await fetch(fileUrl);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error convirtiendo archivo a base64:', error);
    return null;
  }
};

const precargarRecursosPDF = async () => {
  try {
    const [logoIzquierdo, logoDerecho, logoInstagram, logoEmail, logoFacebook, logoTelefono] = await Promise.all([
      fileToBase64(logoGymart1),
      fileToBase64(logoGymart2),
      fileToBase64(instagramImg),
      fileToBase64(emailImg),
      fileToBase64(facebookImg),
      fileToBase64(telefonoImg)
    ]);

    const impactBase64 = await fileToBase64(impactFont);

    return {
      logoIzquierdo,
      logoDerecho,
      logoInstagram,
      logoEmail,
      logoFacebook,
      logoTelefono,
      impactFont: impactBase64
    };
  } catch (error) {
    console.error('Error precargando recursos:', error);
    return {
      logoIzquierdo: null,
      logoDerecho: null,
      logoInstagram: null,
      logoEmail: null,
      logoFacebook: null,
      logoTelefono: null,
      impactFont: null
    };
  }
};

// ============================================
// 4. FUNCIÓN PRINCIPAL
// ============================================

export const generarContratoGymartPDF = async (datos) => {
  const doc = new jsPDF();
  
  // ============================================
  // 5. FECHA ACTUAL CON HORA
  // ============================================
  const fechaActual = new Date();
  const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  const diaActual = fechaActual.getDate().toString().padStart(2, '0');
  const mesActual = meses[fechaActual.getMonth()];
  const añoActual = fechaActual.getFullYear();

  let horas = fechaActual.getHours();
  let minutos = fechaActual.getMinutes();
  let ampm = horas >= 12 ? 'PM' : 'AM';
  horas = horas % 12;
  horas = horas ? horas : 12;
  const horaFormateada = horas.toString().padStart(2, '0') + ':' + minutos.toString().padStart(2, '0') + ' ' + ampm;

  const fechaCompleta = `${mesActual} ${diaActual}, ${añoActual} - ${horaFormateada}`;
  
  // ============================================
  // 6. CARGAR RECURSOS
  // ============================================
  const {
    logoIzquierdo,
    logoDerecho,
    logoInstagram,
    logoEmail,
    logoFacebook,
    logoTelefono,
    impactFont
  } = await precargarRecursosPDF();
  
  // ============================================
  // 7. REGISTRAR FUENTE IMPACT
  // ============================================
  if (impactFont) {
    try {
      doc.addFileToVFS('impact.ttf', impactFont);
      doc.addFont('impact.ttf', 'impact', 'normal');
      doc.addFont('impact.ttf', 'impact', 'bold');
    } catch (error) {}
  }

  // ============================================
  // 8. FUNCIONES DE FUENTES
  // ============================================
  
  const setFuenteTexto = (estilo = 'normal') => {
    doc.setFont('times', estilo);
  };

  const setFuenteTitulo = () => {
    doc.setFont('times', 'bold');
  };

  const setFuenteImpact = () => {
    if (impactFont) {
      doc.setFont('impact', 'normal');
    } else {
      doc.setFont('helvetica', 'bold');
    }
  };

  // ============================================
  // 9. CONFIGURACIÓN INICIAL
  // ============================================
  const margen = 20;
  const anchoUtil = 170;
  let y = 20;

  // ============================================
  // 10. DETERMINAR RESPONSABLE
  // ============================================
  
  const firmaDigital = datos.firmaDigital || null;
  
  const responsable = datos.tipoResponsable === 'padre' ? 
    { 
      nombre: (datos.nombrePadre || '').toUpperCase(), 
      cedula: (datos.cedulaPadre || '').toUpperCase(), 
      tipo: 'Padre',
      telefono: (datos.telefonoPadre || datos.telefono || '').toUpperCase(),
      firma: firmaDigital
    } : 
    datos.tipoResponsable === 'madre' ?
    { 
      nombre: (datos.nombreMadre || '').toUpperCase(), 
      cedula: (datos.cedulaMadre || '').toUpperCase(), 
      tipo: 'Madre',
      telefono: (datos.telefonoMadre || datos.telefono || '').toUpperCase(),
      firma: firmaDigital
    } :
    { 
      nombre: (datos.nombreRepresentante || '').toUpperCase(), 
      cedula: (datos.cedulaRepresentante || '').toUpperCase(), 
      tipo: 'Representante Legal',
      telefono: (datos.telefonoRepresentante || datos.telefono || '').toUpperCase(),
      firma: firmaDigital
    };

  const datosMenor = {
    nombre: (datos.nombreMenor || '').toUpperCase(),
    documento: (datos.numeroDocumentoMenor || '').toUpperCase(),
    tipoDocumento: datos.tipoDocumentoMenor || ''
  };

  const mostrarPadre = datos.tipoResponsable === 'padre';
  const mostrarMadre = datos.tipoResponsable === 'madre';
  const mostrarRepresentante = datos.tipoResponsable === 'representante';

  // ============================================
  // 11. FUNCIONES AUXILIARES
  // ============================================

  const agregarTexto = (texto, x, yPos, maxWidth = anchoUtil) => {
    const parrafos = texto.split('\n');
    let yActual = yPos;

    parrafos.forEach(parrafo => {
      if (parrafo.trim() === '') {
        yActual += 5;
        return;
      }

      const lineas = doc.splitTextToSize(parrafo.trim(), maxWidth);

      lineas.forEach((linea, index) => {
        const esUltimaLinea = index === lineas.length - 1;

        if (esUltimaLinea) {
          doc.text(linea, x, yActual);
        } else {
          const palabras = linea.trim().split(' ').filter(p => p !== '');

          if (palabras.length <= 1) {
            doc.text(linea, x, yActual);
          } else {
            const anchoTexto = doc.getTextWidth(palabras.join(''));
            const espacioTotal = maxWidth - anchoTexto;
            const espacioEntrePalabras = espacioTotal / (palabras.length - 1);

            let xActual = x;
            palabras.forEach((palabra, i) => {
              doc.text(palabra, xActual, yActual);
              if (i < palabras.length - 1) {
                xActual += doc.getTextWidth(palabra) + espacioEntrePalabras;
              }
            });
          }
        }

        yActual += 5;
      });
    });

    return yActual;
  };

  const agregarEncabezado = () => {
    let yHeader = 10;
    
    if (logoIzquierdo) {
      try { doc.addImage(logoIzquierdo, 'PNG', 8, yHeader, 20, 20); } catch (e) {}
    }
    if (logoDerecho) {
      try { doc.addImage(logoDerecho, 'PNG', 188, yHeader, 20, 20); } catch (e) {}
    }
    
    doc.setTextColor(80, 80, 80);
    
    doc.setFontSize(16);
    setFuenteImpact();
    doc.text('CLUB GYMART', 105, yHeader + 6, { align: 'center' });
    
    yHeader += 11;
    
    doc.setFontSize(9);
    setFuenteImpact();
    doc.text('GIMNASIA ARTISTICA', 105, yHeader, { align: 'center' });
    
    yHeader += 5;
    
    doc.setFontSize(9);
    setFuenteImpact();
    doc.text('FEMENINA Y MASCULINA', 105, yHeader, { align: 'center' });
    
    yHeader += 5;
    
    doc.setFontSize(7);
    setFuenteTexto('normal');
    doc.text('Teléfono: 3155555949 – 3176796342 – 3184795015', 105, yHeader, { align: 'center' });
    
    yHeader += 3.5;
    
    doc.setFontSize(7);
    doc.text('clubgymart@gmail.com', 105, yHeader, { align: 'center' });
    
    doc.setDrawColor(80, 80, 80);
    doc.setLineWidth(0.1);
    doc.line(15, yHeader + 3, 195, yHeader + 3);
    
    return yHeader + 8;
  };

  const agregarMarcaDeAguaInicio = () => {
    doc.setFontSize(100);
    doc.setTextColor(220, 220, 220);
    setFuenteImpact();
    doc.text('GYMART', 105, 160, { align: 'center' });
    doc.setTextColor(0, 0, 0);
  };

  const agregarPiePagina = (pagina) => {
    doc.setDrawColor(80, 80, 80);
    doc.setLineWidth(0.1);
    doc.line(15, 280, 195, 280);
    
    doc.setTextColor(80, 80, 80);
    doc.setFontSize(8);
    doc.setFont('impact', 'bold');
    doc.text('PERSONERIA JURIDICA 0983 DE MAYO 28 DE 2012', 105, 285, { align: 'center' });
    doc.text(`Pagina ${pagina} de 8`, 105, 290, { align: 'center' });
    
    doc.setTextColor(0, 0, 0); // ← AGREGA ESTA LÍNEA
    setFuenteTexto('normal');
  };

  const agregarLineaDelgada = (x1, y1, x2, y2) => {
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.1);
    doc.line(x1, y1, x2, y2);
  };

  const agregarFirmaImagen = (firmaBase64, x, y, ancho = 60, alto = 25) => {
    if (!firmaBase64) return false;
    try {
      let base64Data = firmaBase64;
      if (firmaBase64.includes(',')) {
        base64Data = firmaBase64.split(',')[1];
      }
      doc.addImage(base64Data, 'PNG', x, y, ancho, alto);
      return true;
    } catch (error) {
      console.error('Error agregando firma:', error);
      return false;
    }
  };

  const agregarCampoFirma = (x, y, texto, firmaBase64 = null) => {
    let yActual = y;
    
    if (firmaBase64) {
      agregarFirmaImagen(firmaBase64, x, yActual, 60, 25);
      yActual += 25;
    }
    
    agregarLineaDelgada(x, yActual, x + 100, yActual);
    yActual += 5;
    
    doc.setFontSize(8);
    setFuenteTexto('normal');
    doc.text(texto, x, yActual);
    
    return yActual + 10;
  };

  // ============================================
  // ============ PÁGINA 1 ============
  // ============================================
  
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 5;

  doc.setTextColor(0, 0, 0);
  setFuenteTitulo();
  doc.setFontSize(10);
  doc.text('DOCUMENTACIÓN REQUERIDA DE AFILIACIÓN', 105, y, { align: 'center' });
  y += 8;

  setFuenteTexto('normal');
  doc.setFontSize(9);
  
  const docRequerida = [
    '1. Copia del documento de identidad del afiliado TI / RCN / CC o en medio magnético formato (pdf) al Correo clubgymart@gmail.com',
    '2. Foto tipo documento en medio magnético (pdf) al Correo clubgymart@gmail.com',
    '3. Institución Educativa',
    '4. Certificado EPS',
    '5. Número de contacto',
    '6. Correo Electrónico',
    '7. Copia del documento de identidad del Acudiente CC o en medio magnético formato (pdf) al Correo clubgymart@gmail.com'
  ];

  docRequerida.forEach(item => {
    y = agregarTexto(item, margen, y, anchoUtil - 10);
    y += 3;
  });

  y += 5;
  
  setFuenteTitulo();
  doc.setFontSize(9);
  doc.text('INFORMACIÓN GENERAL', 105, y, { align: 'center' });
  y += 4;
  doc.text('CLUB GYMART', 105, y, { align: 'center' });
  y += 12;

  setFuenteTexto('normal');
  const tamanoLogo = 12;
  const espacioColumnas = 45;
  const inicioRedes = y;

  if (logoInstagram) {
    try { doc.addImage(logoInstagram, 'PNG', margen, inicioRedes, tamanoLogo, tamanoLogo); } catch (e) {}
  }
  doc.setFontSize(7);
  doc.text('Clubgymart', margen + tamanoLogo/2, inicioRedes + tamanoLogo + 4, { align: 'center' });

  if (logoEmail) {
    try { doc.addImage(logoEmail, 'PNG', margen + espacioColumnas, inicioRedes, tamanoLogo, tamanoLogo); } catch (e) {}
  }
  doc.setFontSize(6);
  doc.text('clubgymart@gmail.com', margen + espacioColumnas + tamanoLogo/2, inicioRedes + tamanoLogo + 4, { align: 'center' });

  if (logoFacebook) {
    try { doc.addImage(logoFacebook, 'PNG', margen + (espacioColumnas * 2), inicioRedes, tamanoLogo, tamanoLogo); } catch (e) {}
  }
  doc.setFontSize(7);
  doc.text('ClubGymart', margen + (espacioColumnas * 2) + tamanoLogo/2, inicioRedes + tamanoLogo + 4, { align: 'center' });

  if (logoTelefono) {
    try { doc.addImage(logoTelefono, 'PNG', margen + (espacioColumnas * 3), inicioRedes, tamanoLogo, tamanoLogo); } catch (e) {}
  }
  doc.setFontSize(7);
  doc.text('3155555949', margen + (espacioColumnas * 3) + tamanoLogo/2, inicioRedes + tamanoLogo + 4, { align: 'center' });

  y += tamanoLogo + 12;
  
  setFuenteTexto('normal');
  doc.setFontSize(8);
  
  const infoGeneral = [
    '* El Pago de las mensualidades deben realizarse los primeros cinco (5) días de cada mes. a través del LINK de pago establecido ó efectivo en las instalaciones del Club.',
    '* No está permitido el uso de prendas de otras instituciones diferentes a la del club, durante el entrenamiento.',
    '* Para la clase diagnostica deberán firmar el consentimiento de Responsabilidad civil. De lo contrario No podrá recibir la clase.',
    '* Es de carácter Obligatorio acceder a la Póliza Institucional de Accidentes.',
    '* Durante la práctica no se debe utilizar prendas de vestir anchas, accesorios ni tener el cabello suelto.',
    '* Conocer Lineamientos Técnicos, Deportistas, Papas y Entrenadores (LTD-LTP-LTE)',
    '* Firmar formatos de afiliación.',
    '* En caso de haber pertenecido a otra institución deportiva presentar Paz y Salvo de esta.',
    '* En caso de retiro del Club Gymart solicitar Paz y Salvo de Afiliación.'
  ];

  infoGeneral.forEach(item => {
    y = agregarTexto(item, margen, y, anchoUtil - 10);
    y += 3;
  });

  agregarPiePagina(1);
  
  // ============================================
  // ============ PÁGINA 2 ============
  // ============================================
  doc.addPage();
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 5;

  doc.setTextColor(0, 0, 0);
  setFuenteTexto('normal');
  doc.setFontSize(10);
  doc.text('INSCRITO A LA SECRETARÍA DE DEPORTE MUNICIPAL DE CALDAS', 105, y, { align: 'center' });
  y += 12;
  
  setFuenteTitulo();
  doc.setFontSize(10);
  doc.text('EXIMIENTE DE RESPONSABILIDAD', margen, y);
  y += 10;

  setFuenteTexto('normal');
  doc.setFontSize(9);
  
  const textoEximente = `De manera consciente, libre y voluntaria me permito manifestar que he leído y aceptado previamente en su integridad, el presente documento legal, por medio del cual eximo de toda responsabilidad y, renuncio a todo tipo de reclamación y/o indemnización asociada a la expresa asunción del riesgo por las actividades planeadas y desarrolladas dentro de esta ciudad o cualquier lugar del país o territorio extranjero por el CLUB DEPORTIVO GYMART.`;
  
  y = agregarTexto(textoEximente, margen, y);
  y += 10;

  // --- NUMERAL 1 ---
  setFuenteTitulo();
  doc.text('1.', margen, y);
  setFuenteTexto('normal');
  
  doc.text('Yo', margen + 10, y);
  const nombreX = margen + 18;
  doc.text(responsable.nombre || '____________________', nombreX, y);
  agregarLineaDelgada(nombreX, y + 1, nombreX + 70, y + 1);

  const textoIdentificacion = 'con No. de identificación';
  const anchoTextoIdent = doc.getTextWidth(textoIdentificacion);
  doc.text(textoIdentificacion, nombreX + 75, y);

  const cedulaX = nombreX + 75 + anchoTextoIdent + 2;
  doc.text(responsable.cedula || '_______________', cedulaX, y);
  agregarLineaDelgada(cedulaX, y + 1, cedulaX + 35, y + 1);
  
  y += 5;
  const decl1 = `declaro haber leído este documento es su totalidad. Con mi firma abajo escrita declaro estar de acuerdo con cada uno de los numerales de este documento.`;
  y = agregarTexto(decl1, margen + 10, y, anchoUtil - 15);
  y += 7;

  // --- NUMERAL 2 ---
  setFuenteTitulo();
  doc.text('2.', margen, y);
  setFuenteTexto('normal');
  const decl2 = `Yo declaro que mi hijo (a) realiza la práctica de gimnasia artística por voluntad propia, conociendo de ante mano que esta práctica deportiva conlleva riesgos significativos, y que su practica negligente no sujeta a las Normas del Club Deportivo Gymart, puede producir lesiones físicas leves o graves, inclusive la muerte o daños a propiedad de terceros.`;
  y = agregarTexto(decl2, margen + 10, y, anchoUtil - 15);
  y += 7;

  // --- NUMERAL 3 ---
  setFuenteTitulo();
  doc.text('3.', margen, y);
  setFuenteTexto('normal');
  const decl3 = `Yo declaro que toda la información suministrada de la hoja de vida es veraz y que todas las preguntas con respecto a las instalaciones han sido respondidas a mi satisfacción. yo declaro que mi hijo (a) tiene una condición física sana y adecuada para realizar ejercicio, que no padecen de afecciones medicas o físicas que pudieran interferir con su seguridad en esta actividad o con la de terceros.`;
  y = agregarTexto(decl3, margen + 10, y, anchoUtil - 15);
  y += 7;

  // --- NUMERAL 4 ---
  setFuenteTitulo();
  doc.text('4.', margen, y);
  setFuenteTexto('normal');

  if (mostrarRepresentante) {
    const textoPrevioN4 = 'Como padre o acudiente autorizado de los padres';
    const anchoPrevioN4 = doc.getTextWidth(textoPrevioN4);
    const xInicioN4 = margen + 10;

    doc.text(textoPrevioN4, xInicioN4, y);

    const xNombreN4 = xInicioN4 + anchoPrevioN4 + 2;
    const nombreRepN4 = responsable.nombre || '____________________';
    doc.text(nombreRepN4, xNombreN4+10, y);
    agregarLineaDelgada(xNombreN4, y + 1, xNombreN4 + 90, y + 1);

    y += 5;

    const decl4resto = `declaro que he leído este documento es su totalidad y en mi nombre y el de mi cónyuge (si lo hubiere) o en nombre de los padres del menor de edad, acepto voluntariamente todos los numerales descritos en este documento. Yo en mi nombre y el de mi cónyuge o en nombre de los padres del menor de edad, mi familia herederos o sucesores, cesionarios o cualquier otra persona; de manera intencional y voluntaria; exonero y libero de toda responsabilidad a el Club Deportivo Gymart y a sus encargados y todas las demás personas o entidades que actúan en cualquier calidad en nombre de esta; de pago e indemnización que se deriven, directa o indirectamente, de su muerte, daños, accidentes, lesiones o enfermedades de cualquier naturaleza que le sobrevinieren a su persona, bienes o tercero, producto de la participación en las actividades de la gimnasia o estadía en las instalaciones del CLUB DEPORTIVO GYMART o cualquier otra actividad al aire libre u otro lugar, relacionado con los servicios que ofrece y organiza el CLUB DEPORTIVO GYMART.`;
    y = agregarTexto(decl4resto, margen + 10, y, anchoUtil - 15);

  } else {
    const decl4 = `Como padre o acudiente autorizado de los padres declaro que he leído este documento es su totalidad y en mi nombre y el de mi cónyuge (si lo hubiere) o en nombre de los padres del menor de edad, acepto voluntariamente todos los numerales descritos en este documento. Yo en mi nombre y el de mi cónyuge o en nombre de los padres del menor de edad, mi familia herederos o sucesores, cesionarios o cualquier otra persona; de manera intencional y voluntaria; exonero y libero de toda responsabilidad a el Club Deportivo Gymart y a sus encargados y todas las demás personas o entidades que actúan en cualquier calidad en nombre de esta; de pago e indemnización que se deriven, directa o indirectamente, de su muerte, daños, accidentes, lesiones o enfermedades de cualquier naturaleza que le sobrevinieren a su persona, bienes o tercero, producto de la participación en las actividades de la gimnasia o estadía en las instalaciones del CLUB DEPORTIVO GYMART o cualquier otra actividad al aire libre u otro lugar, relacionado con los servicios que ofrece y organiza el CLUB DEPORTIVO GYMART.`;
    y = agregarTexto(decl4, margen + 10, y, anchoUtil - 15);
  }

  y += 10;

  agregarPiePagina(2);

  // ============================================
  // ============ PÁGINA 3 ============
  // ============================================
  doc.addPage();
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 5;

  doc.setTextColor(0, 0, 0);
  setFuenteTexto('normal');
  doc.setFontSize(9);
  
  const textoFinal = `Declaro bajo gravedad de juramento que he entendido perfectamente todo lo que se me ha informado y explicado, y que tengo plena conciencia de los riesgos que me han advertido, así como de las limitaciones y restricciones como padre, madre de familia y/o acudiente de mi hijo.`;
  
  y = agregarTexto(textoFinal, margen, y);
  y += 15;

  doc.text('Fecha:', margen, y);
  doc.text(fechaCompleta, margen + 10, y);
  agregarLineaDelgada(margen + 10, y + 1, margen + 60, y + 1);
  y += 15;

  // ← AGREGA ESTO AQUÍ
doc.text('Mes:', margen, y);
doc.text(mesActual, margen + 12, y);
agregarLineaDelgada(margen + 12, y + 1, margen + 50, y + 1);

doc.text('Día:', margen + 55, y);
doc.text(diaActual, margen + 67, y);
agregarLineaDelgada(margen + 67, y + 1, margen + 90, y + 1);

doc.text('Año:', margen + 95, y);
doc.text(añoActual.toString(), margen + 107, y);
agregarLineaDelgada(margen + 107, y + 1, margen + 130, y + 1);
y += 15;

  doc.text('Nombres y apellidos del menor:', margen, y);
  const nombreMenorX = margen + 45;
  doc.text(datosMenor.nombre || '____________________', nombreMenorX, y);
  agregarLineaDelgada(nombreMenorX, y + 1, nombreMenorX + 70, y + 1);
  y += 10;

  doc.text('Documento de identidad del menor: T.I', margen, y);
  
  // Cuadro TI — justo después del texto
  const xTI = margen + doc.getTextWidth('Documento de identidad del menor: T.I') + 2;
  doc.rect(xTI, y - 3, 3, 3);
  if (datosMenor.tipoDocumento === 'TI') {
    doc.text('X', xTI + 0.5, y - 0.5);
  }

  // RCN — justo después del cuadro TI
  const xRCN = xTI + 6;
  doc.text('RCN', xRCN, y);

  // Cuadro RCN — justo después de RCN
  const xCuadroRCN = xRCN + doc.getTextWidth('RCN') + 2;
  doc.rect(xCuadroRCN, y - 3, 3, 3);
  if (datosMenor.tipoDocumento === 'RCN') {
    doc.text('X', xCuadroRCN + 0.5, y - 0.5);
  }

  // No. — justo después del cuadro RCN
  const xNo = xCuadroRCN + 6;
  doc.text('No.', xNo, y);

  // Número documento — justo después de No.
  const numDocMenorX = xNo + doc.getTextWidth('No.') + 2;
  doc.text(datosMenor.documento || '_______________', numDocMenorX, y);
  agregarLineaDelgada(numDocMenorX, y + 1, numDocMenorX + 50, y + 1);
  y += 20;

  y = agregarCampoFirma(
    margen,
    y,
    'FIRMA DEL PADRE, MADRE DE FAMILIA Y/O ACUDIENTE DEL MENOR',
    responsable.firma
  );
  y += 10;

  doc.text('C.C.', margen, y);
  const ccX = margen + 10;
  doc.text(responsable.cedula || '_______________', ccX, y);
  agregarLineaDelgada(ccX, y + 1, ccX + 50, y + 1);
  
  agregarPiePagina(3);

// ============================================
  // ============ PÁGINA 4 ============
  // ============================================
  doc.addPage();
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 10;

  doc.setTextColor(0, 0, 0);
  setFuenteTitulo();
  doc.setFontSize(9);
  doc.text('CONSENTIMIENTO PARA SALVAGUARDAR LA INTEGRIDAD FÍSICA', 105, y, { align: 'center' });
  y += 4;
  doc.text('DEL MENOR DE EDAD', 105, y, { align: 'center' });
  y += 12;

  setFuenteTexto('normal');
  doc.setFontSize(9);

  const nombreRespVal = responsable.nombre || '____________________';
  const cedulaRespVal = responsable.cedula || '_______________';
  const nombreMenorValP4 = datosMenor.nombre || '___________';
  const docMenorVal = datosMenor.documento || '_______________';

  // --- LÍNEA 1 ---
  let xCursor = margen;

  // "Yo "
  doc.text('Yo ', xCursor, y);
  xCursor += doc.getTextWidth('Yo ');

  // [NOMBRE] — línea fija de 40mm
  doc.text(nombreRespVal, xCursor + 1, y);
  agregarLineaDelgada(xCursor, y + 1, xCursor + 55, y + 1);
  xCursor += 41;

  // " con No. de identificación "
  doc.text(' con No. de identificación ', xCursor+14, y);
  xCursor += doc.getTextWidth(' con No. de identificación ');

  // [CEDULA] — línea fija de 22mm
  doc.text(cedulaRespVal, xCursor + 15, y);
  agregarLineaDelgada(xCursor+15, y + 1, xCursor + 32, y + 1);
  xCursor += 23;

  // " en calidad de Representante Legal del niño, niña"
  doc.text(' en calidad de Representante Legal del niño, niña', xCursor+10, y);
  y += 5;

  // --- LÍNEA 2 ---
  xCursor = margen;

  // "o adolescente "
  doc.text('o adolescente ', xCursor, y);
  xCursor += doc.getTextWidth('o adolescente ');

  // [NOMBRE MENOR] — línea fija de 40mm
  doc.text(nombreMenorValP4, xCursor + 1, y);
  agregarLineaDelgada(xCursor, y + 1, xCursor + 50, y + 1);
  xCursor += 41;

  // " identificado con R.C.N o T.I "
  doc.text(' identificado con R.C.N o T.I ', xCursor+10, y);
  xCursor += doc.getTextWidth(' identificado con R.C.N o T.I ') +5;

  // [NUMERO] — línea fija de 22mm
  doc.text(docMenorVal, xCursor + 7, y);
  agregarLineaDelgada(xCursor+7, y + 1, xCursor + 22, y + 1);
  xCursor += 23;

  // " declaro haber leído este documento"
  doc.text(' declaro haber leído este documento', xCursor, y);
  y += 5;

  // --- LÍNEA 3 ---
  doc.text('en su totalidad. Con mi firma abajo escrita declaro estar de acuerdo con cada uno de los numerales de este', margen, y);
  y += 5;

  // --- LÍNEA 4 ---
  doc.text('documento.', margen, y);
  y += 8;

  // --- CUERPO DEL CONSENTIMIENTO ---
  const textoConsentimiento2 = `Declaro que mi hijo (a) realiza la práctica de gimnasia artística por voluntad propia, conociendo de antemano que esta práctica deportiva conlleva riesgos significativos, y que su práctica negligente no sujeta a las Normas del Club Deportivo GYMART, puede producir lesiones físicas leves o graves, inclusive la muerte o daños a propiedad de terceros.

Soy consciente que en la búsqueda de minimizar lesiones y salvaguardar la integridad física, teniendo conocimiento que esta disciplina deportiva es catalogada como de alto riesgo, entiendo y comprendo los cuidados y ayudas que se deben propender en todo momento para reducir el riesgo donde se pueda ver afectada la integridad física del menor deportista. Por tal motivo, autorizo de manera libre y espontánea en mi calidad de padre y/o representante legal del menor, para que ante cualquier situación donde se vea expuesta o vulnerada su condición e integridad física, el entrenador (a) podrá y tendrá la obligación de llevar a cabo ayudas donde de manera indispensable estos tengan contacto corporal directo con el menor, con el objeto de prevenir o mitigar lesiones.

Declaro bajo gravedad de juramento que he entendido perfectamente todo lo que se me ha informado y explicado, sobre salvaguardar la integridad física y que tengo plena conciencia de los riesgos que me han advertido, dejando libre y eximido de cualquier tipo de responsabilidad civil, penal, disciplinaria, u otras al CLUB DEPORTIVO GYMART y entrenadores.

Para constancia de lo anterior se firma y otorga en la ciudad de Manizales.`;

  y = agregarTexto(textoConsentimiento2, margen, y);
  y += 15;

  // --- FECHA ---
  doc.text('Fecha:', margen, y);
  doc.text(fechaCompleta, margen + 15, y);
  agregarLineaDelgada(margen + 15, y + 1, 70, y + 1);
  y += 10;

  doc.text('Mes:', margen, y);
  doc.text(mesActual, margen + 10, y);
  agregarLineaDelgada(margen + 10, y + 1, margen + 50, y + 1);

  doc.text('Día:', margen + 55, y);
  doc.text(diaActual, margen + 65, y);
  agregarLineaDelgada(margen + 65, y + 1, margen + 90, y + 1);

  doc.text('Año:', margen + 95, y);
  doc.text(añoActual.toString(), margen + 105, y);
  agregarLineaDelgada(margen + 105, y + 1, margen + 130, y + 1);
  y += 15;

  // --- NOMBRE ---
  doc.text('NOMBRE', margen, y);
  const nombreFirmaX = margen + doc.getTextWidth('NOMBRE') + 3;
  doc.text(nombreRespVal, nombreFirmaX, y);
  agregarLineaDelgada(nombreFirmaX, y + 1, 90, y + 1);
  y += 15;

  // --- FIRMA ---
  if (responsable.firma) {
    agregarFirmaImagen(responsable.firma, margen, y, 60, 25);
    y += 25;
  }
  agregarLineaDelgada(margen, y + 1, 120, y + 1);
  y += 5;
  doc.text('FIRMA DEL PADRE, MADRE DE FAMILIA Y/O ACUDIENTE DEL MENOR', margen, y);
  y += 10;

  // --- C.C. y TEL ---
  doc.text('C.C.', margen, y);
  const ccConsentX = margen + doc.getTextWidth('C.C.') + 2;
  doc.text(cedulaRespVal, ccConsentX, y);
  agregarLineaDelgada(ccConsentX, y + 1, ccConsentX + 50, y + 1);

  doc.text('Tel.', ccConsentX + 55, y);
  const telX = ccConsentX + 65;
  doc.text(responsable.telefono || '_______________', telX, y);
  agregarLineaDelgada(telX, y + 1, telX + 40, y + 1);

  y += 20;
  agregarPiePagina(4);
 // ============================================
  // ============ PÁGINA 5 ============
  // ============================================
  doc.addPage();
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 10;

  doc.setTextColor(0, 0, 0);
  setFuenteTitulo();
  doc.setFontSize(10);
  doc.text('AUTORIZACIÓN PARA LA PUBLICIDAD DE IMÁGENES DE MENORES', 105, y, { align: 'center' });
  y += 12;

  setFuenteTexto('normal');
  doc.setFontSize(9);

  const textoAutorizacion1 = `En virtud de lo expresado por la Corte Constitucional en Sentencia C-748 de 2011 "...se interpreta que los datos de los niños, las niñas y adolescentes pueden ser objeto de tratamiento siempre y cuando no se ponga en riesgo la prevalencia de sus derechos fundamentales e inequívocamente responda a la realización del principio de su interés superior, cuya aplicación específica devendrá del análisis de cada caso en particular."`;

  y = agregarTexto(textoAutorizacion1, margen, y);
  y += 5;

  // Línea 1
  const textoPreNombre5 = 'Es así como en calidad de Representante Legal del niño, niña o adolescente';
  const anchoPreNombre5 = doc.getTextWidth(textoPreNombre5);
  doc.text(textoPreNombre5, margen, y);
  const xNombreMenor5 = margen + anchoPreNombre5 + 4;
  const nombreMenorVal5 = datosMenor.nombre || '___________';
  doc.text(nombreMenorVal5, xNombreMenor5 + 10, y);
  agregarLineaDelgada(xNombreMenor5, y + 1, 191, y + 1);
  y += 5;

  // Línea 2
  const textoIdDoc5 = 'identificado con R.C.N o T.I';
  doc.text(textoIdDoc5, margen, y);
  const documentoX = margen + doc.getTextWidth(textoIdDoc5) + 2;
  const docVal5 = datosMenor.documento || '_______________';
  doc.text(docVal5, documentoX, y);
  const anchoDoc5 = doc.getTextWidth(docVal5);
  const finDoc5 = documentoX + anchoDoc5 + 2;
  agregarLineaDelgada(documentoX, y + 1, finDoc5, y + 1);

  const textoDeclaro5a = 'declaro conocer que los datos de los menores de edad son datos sensibles de acuerdo a la';
  const xDeclaro5 = finDoc5 + 2;
  const anchoRestante5 = 195 - xDeclaro5;
  const lineasDeclaro5a = doc.splitTextToSize(textoDeclaro5a, anchoRestante5);
  doc.text(lineasDeclaro5a[0], xDeclaro5, y);
  y += 5;

  // Línea 3
  const textoDeclaro5b = 'normatividad vigente, por lo tanto, NO me encuentro obligado a autorizar el tratamiento de los mismos, sin embargo, declaro otorgar, voluntaria y expresamente, las siguientes autorizaciones:';
  y = agregarTexto(textoDeclaro5b, margen, y, anchoUtil);
  y += 5;

  // Autorizaciones 1-4
  const autorizaciones = [
    '1. Autorizo el uso de su imagen, fotografía, voz, sonidos, filmaciones magnéticas y cualquier otro registro audiovisual, para ser usadas por el CLUB DEPORTIVO GYMART como parte del material publicitario promocional, interno y externo, que en el club se difunda públicamente por cualquier medio, sea medios impresos, internet, televisión, radio y cualquier otro medio de difusión, para el desarrollo de sus actividades y fines deportivos y/o educativos.',
    '2. EL CLUB GYMART, identificado con NIT 900526863, actuará como RESPONSABLE del tratamiento de datos personales cuyo tratamiento se autoriza, datos que podrá recolectar, usar y tratar conforme a su POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES, conforme a la normatividad vigente ley 1581 del 2012 Protección Datos Personales.',
    '3. Declaro que conozco mis derechos, y los del menor que represento, como titulares de datos personales, que son los previstos en la Constitución y en la ley, especialmente el derecho de conocer, actualizar, rectificar y suprimir la información personal, consultar la información, solicitar prueba de esta autorización, así como el derecho a revocar el consentimiento otorgado para el tratamiento de los datos personales.',
    '4. Reconozco que se me ha indicado que EL CLUB GYMART garantiza la confidencialidad, libertad, seguridad, veracidad, transparencia, acceso y circulación restringida de mis datos y se reserva el derecho de modificar su POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES en cualquier momento. Ante cualquier modificación de dicha política, se compromete a informar a los titulares de los datos personales, a través de su página web y/o de cualquier otro medio idóneo para ello.'
  ];

  autorizaciones.forEach(item => {
    y = agregarTexto(item, margen, y, anchoUtil);
    y += 5;
  });

  // *** DOS PRIMEROS PÁRRAFOS DEL NUMERAL 5 QUE VENÍAN EN PÁGINA 6 ***
  const textoNumeral5Parte1 = `5. Se me ha informado que, en la medida de lo posible, se realizará dicho tratamiento teniendo en cuenta la opinión de los menores titulares de la información personal, considerando su (i) madurez; (ii) autonomía; (iii) capacidad para entender la finalidad del tratamiento; (iv) comprensión de las consecuencias que conlleva el tratamiento.

Teniendo en cuenta lo anterior, autorizo de manera voluntaria, previa, explícita, informada e inequívoca al CLUB GYMART para tratar mis datos, así como los datos del(los) menor(es) a mi cargo, incluyéndolos en sus bases de datos, con el fin de lograr relaciones más efectivas, ágiles y seguras con los ciudadanos, para compartirlos con terceros aliados y/o contratistas, con el objeto de que le presten servicios a éste o en nombre de éste o para la ejecución de estrategias o programas, así como con otras entidades del orden departamental y nacional, bajo las condiciones aquí informadas, y para estar en contacto en caso de existir riesgo frente a la protección de los datos, entre otras finalidades relacionadas con el desarrollo de su objeto y que son referidas en la política ya mencionada.`;

  y = agregarTexto(textoNumeral5Parte1, margen, y);

  agregarPiePagina(5);

// ============================================
  // ============ PÁGINA 6 ============
  // ============================================
  doc.addPage();
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 10;

  doc.setTextColor(0, 0, 0);
  setFuenteTexto('normal');
  doc.setFontSize(9);

  const textoNumeral5Parte2 = `Declaro que la información suministrada lo fue de manera voluntaria y que es correcta, veraz, verificable y actualizada, a la fecha de suscripción de la presente autorización. Que la otorgo con carácter gratuito, por lo que entiendo no recibir ningún tipo de compensación, bonificación o pago de ninguna naturaleza. Reconozco, además que no existe ninguna expectativa sobre los eventuales efectos económicos de la divulgación o sobre el tipo de campaña publicitaria que pueda realizarse a nombre del club GYMART, ya sea de material publicitario, deportivo o cultural.

Mi aceptación explícita se materializa a través de la firma (que debe ser por ambos padres, en caso de ausencia de uno de los padres, se debe demostrar) diligenciamiento y autenticación del presente documento en notaría, además de adjuntar el Registro Civil de Nacimiento del Menor (a efectos de demostrar el parentesco con el menor) o documento que acredite la custodia del menor; así como también mi documento de identidad ampliado a un 150%.`;

  y = agregarTexto(textoNumeral5Parte2, margen, y);
  y += 20;

  setFuenteTitulo();
  doc.setFontSize(10);

  if (mostrarPadre) {
    doc.text('PADRE', margen, y);
    y += 7;
    setFuenteTexto('normal');
    doc.setFontSize(9);

    // NOMBRE
    doc.text('Nombre:', margen, y);
    const nombrePadreX = margen + doc.getTextWidth('Nombre:') + 2;
    doc.text((datos.nombrePadre || '').toUpperCase(), nombrePadreX, y);
    agregarLineaDelgada(nombrePadreX, y + 1, 90, y + 1);
    y += 25; // espacio grande para que la firma no toque el nombre

    // FIRMA
    if (responsable.firma) {
      agregarFirmaImagen(responsable.firma, margen + 15, y - 19, 50, 20);
    }
    doc.text('Firma:', margen, y);
    const xLineaFirmaPadre = margen + doc.getTextWidth('Firma:') + 2;
    agregarLineaDelgada(xLineaFirmaPadre, y + 1, 90, y + 1);
    y += 10;

    // C.C.
    doc.text('C.C.:', margen, y);
    const ccPadreX = margen + doc.getTextWidth('C.C.:') + 2;
    doc.text((datos.cedulaPadre || '').toUpperCase(), ccPadreX, y);
    agregarLineaDelgada(ccPadreX, y + 1, 90, y + 1);
  }

  else if (mostrarMadre) {
    doc.text('MADRE', margen, y);
    y += 7;
    setFuenteTexto('normal');
    doc.setFontSize(9);

    // NOMBRE
    doc.text('Nombre:', margen, y);
    const nombreMadreX = margen + doc.getTextWidth('Nombre:') + 2;
    doc.text((datos.nombreMadre || '').toUpperCase(), nombreMadreX, y);
    agregarLineaDelgada(nombreMadreX, y + 1, 90, y + 1);
    y += 25; // espacio grande para que la firma no toque el nombre

    // FIRMA
    if (responsable.firma) {
      agregarFirmaImagen(responsable.firma, margen + 15, y - 19, 50, 20);
    }
    doc.text('Firma:', margen, y);
    const xLineaFirmaMadre = margen + doc.getTextWidth('Firma:') + 2;
    agregarLineaDelgada(xLineaFirmaMadre, y + 1, 90, y + 1);
    y += 10;

    // C.C.
    doc.text('C.C.:', margen, y);
    const ccMadreX = margen + doc.getTextWidth('C.C.:') + 2;
    doc.text((datos.cedulaMadre || '').toUpperCase(), ccMadreX, y);
    agregarLineaDelgada(ccMadreX, y + 1, 90, y + 1);
  }

  else if (mostrarRepresentante) {
    doc.text('REPRESENTANTE LEGAL', margen, y);
    y += 7;
    setFuenteTexto('normal');
    doc.setFontSize(9);

    // NOMBRE
    doc.text('Nombre:', margen, y);
    const nombreRepX = margen + doc.getTextWidth('Nombre:') + 2;
    doc.text((datos.nombreRepresentante || '').toUpperCase(), nombreRepX, y);
    agregarLineaDelgada(nombreRepX, y + 1, 90, y + 1);
    y += 25; // espacio grande para que la firma no toque el nombre

    // FIRMA
    if (responsable.firma) {
      agregarFirmaImagen(responsable.firma, margen + 15, y - 19, 50, 20);
    }
    doc.text('Firma:', margen, y);
    const xLineaFirmaRep = margen + doc.getTextWidth('Firma:') + 2;
    agregarLineaDelgada(xLineaFirmaRep, y + 1, 90, y + 1);
    y += 10;

    // CÉDULA
    doc.text('Cédula:', margen, y);
    const cedulaRepX = margen + doc.getTextWidth('Cédula:') + 2;
    doc.text((datos.cedulaRepresentante || '').toUpperCase(), cedulaRepX, y);
    agregarLineaDelgada(cedulaRepX, y + 1, 90, y + 1);
  }

  agregarPiePagina(6);
  // ============================================
  // ============ PÁGINA 7 ============
  // ============================================
  doc.addPage();
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 10;

  setFuenteTitulo();
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.text('INFORMACIÓN SOBRE COBROS', 105, y, { align: 'center' });
  y += 12;

  setFuenteTexto('normal');
  doc.setFontSize(9);

  const infoCobros = `MENSUALIDAD: El sistema de recaudo generará automáticamente dentro de los cinco (5) días de cada mes un link de pago para realizarse dentro del mismo termino, el cual será enviado al WhatsApp del acudiente registrado. A quienes por alguna razón no se les genere link de recaudo, deberán realizar dentro del término los pagos en dinero efectivo en las instalaciones del Club. Si dentro del término estipulado no se cumple con este requerimiento, el ingreso a clase por parte del alumno será rechazado por el sistema. En caso si presenta inconvenientes con el pago o solicitudes a fines, deberá realizarlas a través del correo clubgymart@gmail.com o a través de la línea telefónica 315 555 59 49.

NOTA: Si se llegara a reportar novedad por congelamiento de mensualidad, esta deberá informarse con un mínimo de tiempo de treinta (30) días calendario a la dirección administrativa del club, toda vez que el sistema generará automáticamente link de pago el cual no podrá anularse; por defecto será aplicado el cobro de la mensualidad del periodo correspondiente.

AVISO POR CESACION DE ACTIVIDAD DEPORTIVA: Dado el caso, donde el deportista deba ausentarse por motivo de viaje u otra situación especial como incapacidad medica soportada por un periodo de 15 a 30 días; el acudiente o persona responsable, estará en el deber de informar y enviar solicitud a través de los canales oficiales del clubgymart con un tiempo no menor a los 30 días calendario sobre dicha novedad. Asentada en el registro la solicitud, se interrumpirá automáticamente la facturación electrónica correspondiente al periodo de ausencia.

Cada caso será estudiado de acuerdo a la situación especifica reportada por el acudiente.

NO RECUPERACION DE CLASES: Bajo ninguna circunstancia, el clubgymart, ofertara o dispondrá de horarios disponibles de recuperación de clases para sus deportistas. Por esta razón se motiva a todos los deportistas inscritos y a sus acudientes o responsables asistir a los entrenamientos programados conforme al cronograma establecido.

Por ningún motivo, el Club Gymart para efecto de este ítem, realizara devolución de dineros (Remítase a ítem derecho de retracto y devoluciones).

NOTA: El clubgymart garantizara en todo momento el cumplimiento de las horas de entrenamiento tomadas por cada deportista mensualmente. Sin embargo, dado el caso en que el clubgymart, deba suspender actividades por motivos de competencia dentro o fuera del territorio nacional o por situaciones de fuerza mayor; se informara igualmente con anticipacion a todos los interesados, y proporcionara los horarios para el cumplimiento de las horas de entrenamiento que pudieran hacer falta dentro del horario acordado.

RETIRO O CANCELACION DEL SERVICIO: Si un deportista desea realizar el retiro del club GYMART deberá enviar la solicitud al correo clubgymart@gmail.com, exponiendo y justificando el motivo de la cancelación. Siempre que la notificación surja después de dos sesiones tomadas durante el mes, el sistema le generara un cobro parcial de mensualidad. Para los casos en los cuales el usuario haya tomado el servicio entre una (1) y dos (2) sesiones, no habrá lugar a pago de mensualidad y, solo se requerirá la notificación escrita para cancelar la vacante y quedar a paz y salvo. En caso de no hacer un retiro administrativo, pasados 90 días la inscripción se cancela automáticamente.`;

  y = agregarTexto(infoCobros, margen, y);

  agregarPiePagina(7);

// ============================================
  // ============ PÁGINA 8 ============
  // ============================================
  doc.addPage();
  agregarMarcaDeAguaInicio();
  y = agregarEncabezado();
  y += 10;

  doc.setTextColor(0, 0, 0);
  setFuenteTexto('normal');
  doc.setFontSize(9);

  const infoCobros2 = `DERECHO DE RETRACTO Y DEVOLUCIONES SOBRE MENSUALIDADES Y MATRICULAS
El deportista o tutor al momento de cancelar la mensualidad y matricula, accede a los servicios formativos deportivos del club GYMART. El no acceder a los servicios no le habilita el derecho de retractarse o solicitar devolución. Para casos de lesiones, incapacidades o congelamiento de mensualidad, se atenderá con lo dispuesto en el respectivo item.

Toda situación especial aquí no estipulada, será analizada por la dirección administrativa del club para atender de manera justa la solución satisfactoria de la novedad.`;

  y = agregarTexto(infoCobros2, margen, y);
  y += 20;

  setFuenteTitulo();
  doc.setFontSize(10);

  if (mostrarPadre) {
    doc.text('PADRE', margen, y);
    y += 7;
    setFuenteTexto('normal');
    doc.setFontSize(9);

    // NOMBRE
    doc.text('Nombre:', margen, y);
    const nombrePadreX8 = margen + doc.getTextWidth('Nombre:') + 2;
    doc.text((datos.nombrePadre || '').toUpperCase(), nombrePadreX8, y);
    agregarLineaDelgada(nombrePadreX8, y + 1, 90, y + 1);
    y += 26; // espacio grande

    // FIRMA
    if (responsable.firma) {
      agregarFirmaImagen(responsable.firma, margen + 15, y - 19, 50, 20);
    }
    doc.text('Firma:', margen, y);
    const xLineaFirmaP8 = margen + doc.getTextWidth('Firma:') + 2;
    agregarLineaDelgada(xLineaFirmaP8, y + 1, 90, y + 1);
    y += 10;

    // C.C.
    doc.text('C.C.:', margen, y);
    const ccPadreX8 = margen + doc.getTextWidth('C.C.:') + 2;
    doc.text((datos.cedulaPadre || '').toUpperCase(), ccPadreX8, y);
    agregarLineaDelgada(ccPadreX8, y + 1, 90, y + 1);
  }

  else if (mostrarMadre) {
    doc.text('MADRE', margen, y);
    y += 7;
    setFuenteTexto('normal');
    doc.setFontSize(9);

    // NOMBRE
    doc.text('Nombre:', margen, y);
    const nombreMadreX8 = margen + doc.getTextWidth('Nombre:') + 2;
    doc.text((datos.nombreMadre || '').toUpperCase(), nombreMadreX8, y);
    agregarLineaDelgada(nombreMadreX8, y + 1, 90, y + 1);
    y += 26; // espacio grande

    // FIRMA
    if (responsable.firma) {
      agregarFirmaImagen(responsable.firma, margen + 15, y - 19, 50, 20);
    }
    doc.text('Firma:', margen, y);
    const xLineaFirmaM8 = margen + doc.getTextWidth('Firma:') + 2;
    agregarLineaDelgada(xLineaFirmaM8, y + 1, 90, y + 1);
    y += 10;

    // C.C.
    doc.text('C.C.:', margen, y);
    const ccMadreX8 = margen + doc.getTextWidth('C.C.:') + 2;
    doc.text((datos.cedulaMadre || '').toUpperCase(), ccMadreX8, y);
    agregarLineaDelgada(ccMadreX8, y + 1, 90, y + 1);
  }

  else if (mostrarRepresentante) {
    doc.text('REPRESENTANTE LEGAL', margen, y);
    y += 7;
    setFuenteTexto('normal');
    doc.setFontSize(9);

    // NOMBRE
    doc.text('Nombre:', margen, y);
    const nombreRepX8 = margen + doc.getTextWidth('Nombre:') + 2;
    doc.text((datos.nombreRepresentante || '').toUpperCase(), nombreRepX8, y);
    agregarLineaDelgada(nombreRepX8, y + 1, 90, y + 1);
    y += 26; // espacio grande

    // FIRMA
    if (responsable.firma) {
      agregarFirmaImagen(responsable.firma, margen + 15, y - 19, 50, 20);
    }
    doc.text('Firma:', margen, y);
    const xLineaFirmaR8 = margen + doc.getTextWidth('Firma:') + 2;
    agregarLineaDelgada(xLineaFirmaR8, y + 1, 90, y + 1);
    y += 10;

    // CÉDULA
    doc.text('Cédula:', margen, y);
    const cedulaRepX8 = margen + doc.getTextWidth('Cédula:') + 2;
    doc.text((datos.cedulaRepresentante || '').toUpperCase(), cedulaRepX8, y);
    agregarLineaDelgada(cedulaRepX8, y + 1, 90, y + 1);
  }

  agregarPiePagina(8);

  // ============================================
  // ============ GUARDAR PDF ============
  // ============================================
  const nombreArchivo = `Contrato_Gymart_${datosMenor.nombre.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(nombreArchivo);
  
  return doc;
};